import Vuex from 'vuex';
import enums from './enums';
import forms from './forms';
import * as user from './user';

const createStore = () => {
  return new Vuex.Store({
    modules: {
      enums: {
        ...enums,
        namespaced: true,
      },
      forms: {
        ...forms,
        namespaced: true,
      },
      user: {
        ...user,
        namespaced: true,
      },
    },
    // strict: process.env.NODE_ENV !== 'test',
  });
};

export default {
  store: null,
  getStore() {
    return this.store;
  },
  createFor(vueInstance) {
    vueInstance.use(Vuex);
    this.store = createStore();
    return this.getStore();
  },
};

// if (module.hot) {
//     // accept actions and mutations as hot modules
//     module.hot.accept(['./productSearch/index.js', './productSearch/result.js'], () => {
//         // require the updated modules
//         // have to add .default here due to babel 6 module output
//         const productSearch = require('./productSearch/index.js').default;
//         // swap in the new modules and mutations
//         store.hotUpdate({
//             modules: {
//                 productSearch,
//             },
//         });
//     });
// }
